import React, { useState } from 'react';
import '@styles/GeneralPages.css';
import '@styles/Settings.css';
import MuscleManagement from '@components/MuscleManagement';
import ExerciseManagement from '@components/ExerciseManagement';
import GeneralSettings from '@components/GeneralSettings';

const Settings = () =>  {
  const [showMuscleManagement, setShowMuscleManagement] = useState(false);
  const [showExerciseManagement, setShowExerciseManagement] = useState(false);
  const [showGeneralManagement, setShowGeneralManagement] = useState(false);
  const [activeTab, setActiveTab] = useState('general');

  const renderContent = () => {
    switch (activeTab) {
      case 'muscle':
        // TopNavBar.title = "Muscle Management";
        return <MuscleManagement />;
      case 'exercise':
        return <ExerciseManagement />;
      case 'general':
         return <GeneralSettings />;
      default:
        return null;
    }
  }

  return (
  <div>
    <div className="settings-btn-box">
      <button className={`btnTest ${activeTab === 'muscle' ? 'active' : ''}`} onClick={() => setActiveTab('muscle')}>Muscle</button>
      <button className={`btnTest ${activeTab === 'exercise' ? 'active' : ''}`} onClick={() => setActiveTab('exercise')}>Exercise</button>
      <button className={`btnTest ${activeTab === 'general' ? 'active' : ''}`} onClick={() => setActiveTab('general')}>General</button>
    </div>
    {renderContent()}
  </div>
  )
};

export default Settings;
